import { createFileRoute } from "@tanstack/react-router";
import { routeHead } from "@/lib/routeHead";
import AdminWebVitals from "@/pages/AdminWebVitals";

export const Route = createFileRoute("/admin/web-vitals")({
  component: AdminWebVitals,
  head: () => ({ meta: [...routeHead('AGAPE Site Performance', 'AGAPE internal performance overview.').meta, { name: "robots", content: "noindex, nofollow" }] }),
});
